"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimerSystem = void 0;
const gotti_1 = require("gotti");
const Config_1 = require("../../Config");
const Constants_1 = require("../../../Shared/Constants");
class TimerSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.TIMER);
        this.elapsedDaylightTime = 0;
        this.fullDays = 0;
        this.hoursPassed = 0;
        this.secondsPerHour = Config_1.CONFIG_CONSTANTS.SECONDS_PER_HOUR;
        this.nextHourTime = Config_1.CONFIG_CONSTANTS.SECONDS_PER_HOUR;
        this.secondsPerDay = Config_1.CONFIG_CONSTANTS.SECONDS_PER_HOUR * 24;
        this.totalElapsedTime = null;
        this.isChecking = false;
    }
    onClear() {
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.START_TIMERS:
                this.handleStartTimers(message.data);
                break;
        }
    }
    calculateGameTime(timeStamp) {
        return {
            hours: 1,
            days: 1,
            seconds: 1,
        };
    }
    handleStartTimers(elapsedTime) {
        if (elapsedTime) {
            this.totalElapsedTime = elapsedTime;
        }
        else {
            this.totalElapsedTime = 0;
        }
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    update(delta) {
        var _a;
        if (((_a = this.globals.tileWorld.loadedMap) === null || _a === void 0 ? void 0 : _a.initialized) && !this.globals.tileWorld.isLoading && this.totalElapsedTime !== null) {
            this.totalElapsedTime += delta;
            this.elapsedDaylightTime += delta * 1000;
            if (this.elapsedDaylightTime > this.secondsPerDay) {
                this.fullDays++;
                this.hoursPassed = 0;
                this.elapsedDaylightTime = 0;
                this.nextHourTime = this.secondsPerHour;
                this.dispatchAllLocal({
                    type: 'day-ended',
                    data: this.fullDays,
                });
            }
            else if (this.elapsedDaylightTime > this.nextHourTime) {
                this.hoursPassed++;
                this.nextHourTime += this.secondsPerHour;
                this.dispatchAllLocal({
                    type: 'hour-ended',
                    data: this.hoursPassed,
                });
            }
        }
    }
}
exports.TimerSystem = TimerSystem;
//# sourceMappingURL=module.js.map